export default __webpack_public_path__ + "static/media/eyecatch_pptx.5b7da7d0.png";